<script setup lang="ts">
withDefaults(defineProps<{ spacing?: 'sm' | 'md' | 'lg' }>(), { spacing: 'md' })
</script>
<template><hr class="k-divider" :class="`k-divider--${spacing}`" /></template>
<style scoped>
.k-divider { border: none; border-top: 1px solid var(--k-color-divider); }
.k-divider--sm { margin: var(--k-space-3) 0; }
.k-divider--md { margin: var(--k-space-6) 0; }
.k-divider--lg { margin: var(--k-space-8) 0; }
</style>
